const axios = require("axios");
const MockAdapter = require("axios-mock-adapter");
const mock = new MockAdapter(axios, { delayResponse: 1000 });
export default mock;
